/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PatchOrdersIdMutationRequest, PatchOrdersIdMutationResponse, PatchOrdersIdPathParams, PatchOrdersId400 } from "../entities/PatchOrdersId";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { patchOrdersId } from "../api/patchOrdersId";
import { useMutation } from "@tanstack/react-query";

export const patchOrdersIdMutationKey = () => [{ url: '/orders/:id' }] as const

export type PatchOrdersIdMutationKey = ReturnType<typeof patchOrdersIdMutationKey>

/**
 * @description Обновление цены заказа
 * @summary Обновление цены заказа
 * {@link /orders/:id}
 */
export function usePatchOrdersId<TContext>(options: 
{
  mutation?: UseMutationOptions<PatchOrdersIdMutationResponse, ResponseErrorConfig<PatchOrdersId400>, {id: PatchOrdersIdPathParams["id"], data: PatchOrdersIdMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PatchOrdersIdMutationRequest>> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? patchOrdersIdMutationKey()

  return useMutation<PatchOrdersIdMutationResponse, ResponseErrorConfig<PatchOrdersId400>, {id: PatchOrdersIdPathParams["id"], data: PatchOrdersIdMutationRequest}, TContext>({
    mutationFn: async({ id, data }) => {
      return patchOrdersId(id, data, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}